// Snapshot-style guided assist config per field: the guiding questions Jarvis
// asks, plus the short hover hint. There is no canned auto-write — the member's
// own answers are assembled into the draft (see JarvisFieldAssist). Shared by
// onboarding and Settings so the prompts stay identical in both places.
export interface FieldAssistConfig {
  title: string;
  intro: string;
  questions: string[];
  hint: string;
}

export const FIELD_ASSIST: Record<string, FieldAssistConfig> = {
  bio: {
    title: 'Bio',
    intro: "A few quick prompts and Ask IF will shape your answers into a short intro.",
    questions: [
      'What do you do, and what industry are you in?',
      'Where are you based / where are you from?',
      "What's something you're proud of in your work?",
      'What do you enjoy outside of work?',
    ],
    hint: 'Think: your industry, what you do, where you’re from, what you enjoy.',
  },
  faith_journey: {
    title: 'Faith Journey',
    intro: "Answer what you're comfortable sharing — Ask IF only uses your words.",
    questions: [
      'When did you make your faith your own (not just inherited)?',
      'Was there a moment or season that shaped it?',
      'Where are you in your walk with Jesus right now?',
    ],
    hint: 'Think: when faith became your own, a moment that shaped it, where you are now.',
  },
  why_iron_forums: {
    title: 'Christian business community',
    intro: 'A few prompts to capture why this matters to you right now.',
    questions: [
      "What's missing in your current relationships or community?",
      'What are you hoping to gain — or give?',
      'What season of business or life makes this matter now?',
    ],
    hint: 'Think: what you’re looking for, what you’d offer, the season you’re in.',
  },
  purpose_statement: {
    title: 'Purpose Statement',
    intro: 'A few prompts and Ask IF will shape them into a concise statement.',
    questions: [
      'What drives your work beyond making money?',
      'Who do you serve, and how?',
      'What impact do you want your business to have?',
    ],
    hint: 'Think: what drives you, who you serve, the impact you want.',
  },
};
